import { render, staticRenderFns } from "./roleAddDialog.vue?vue&type=template&id=2bf26b2a&scoped=true&"
import script from "./roleAddDialog.vue?vue&type=script&lang=js&"
export * from "./roleAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./roleAddDialog.vue?vue&type=style&index=0&id=2bf26b2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf26b2a",
  null
  
)

export default component.exports